module.exports = __webpack_public_path__ + "img/4.e6291cab.jpeg";